export const DATA_HOOKS = {
  DATA_STATUS_EMPTY_ATTR: 'empty-list',
};
